<template>
    <div>
        <div class="sobretext">
            <Container>
                <div class="sobretext__layout">
                    <div class="sobretext__image">
                        <img src="@/assets/images/magor.svg"
                             alt="Magor">
                    </div>
                    <div class="sobretext__text">
                        <h1>Sobre</h1>
                        <p>
                            <strong>A Magor completa 15 anos em 2022. Uma agência consolidada, que atende contas de empresas líderes de mercado, referências em suas áreas de atuação. Denis Lastrucci – sócio e diretor de criação – e Fabio Olivieri – sócio e diretor de atendimento – são oriundos de grandes agências de comunicação paulistanas, onde observaram processos de trabalho exageradamente burocráticos, cheios de departamentos e etapas:</strong>
                        </p>
                        <p>
                            <blockquote>
                                Quando nos conhecemos, trabalhando juntos, conversávamos muito sobre como os processos eram demorados e pouco funcionais. E como o maior prejudicado sempre era o cliente. Muitas vezes, campanhas que precisavam de ajustes que demorariam 10 minutos, acabavam levando uma semana, entre atendimento, tráfego, criação, até voltar para o cliente. Isso quando informações preciosas não eram perdidas ao longo do processo." conta Fabio Olivieri.
                            </blockquote>
                        </p>
                        <p>
                            <blockquote>
                                "Nossa proposta, ao fundar a Magor, foi aparar todas as arestas. Na equipe, nos prazos, nos custos internos, nos orçamentos de fornecedores, em tudo. Montar uma equipe com grandes profissionais, enxuta, integrada. Talentosa e rápida. Era isso que sentíamos falta. Era isso que queríamos entregar: criatividade e eficiência com rapidez a um preço competitivo." completa Denis Lastrucci.
                            </blockquote>
                        </p>
                        <p>A partir disso, fundamentamos nossa atuação em 4 pilares: qualidade, prazo, preço e resultado. Na Magor, nos comprometemos com resultados. Pensamos em aumentar vendas. Com essa premissa, já atendemos muitos clientes de diversos segmentos e portes. Todo cliente tem um desafio. E para a gente, ideias boas são aquelas que vencem desafios.</p>
                    </div>
                </div>
            </Container>
        </div>
    </div>
</template>

<script>
import Container from '@/components/Container'
export default {
    name: 'sobretext',
    components: {
        Container,
    },
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.sobretext {
    &__layout {
        min-height: 100rem;
        padding: 8.5rem 0;
        display: grid;
        column-gap: 12.7rem;
        grid-template-areas: "image text";
        grid-template-columns: 6.5rem auto;
        @media(max-width: $max-sm) {
            grid-template-areas: "image" "text";
            grid-template-columns: auto;
            padding: 6.7rem 0 4rem;
            grid-template-rows: 0 auto;
        }
    }
    &__text {
        grid-area: text;
        width: 73rem;
        @media(max-width: $max-sm) {
            width: 100%;
        }
        h1 {
            font-size: 7rem;
            font-weight: 900;
            color: #FF3C3C;
            margin-bottom: 4.7rem;
            @media(max-width: $max-sm) {
                font-size: 3rem;
                margin-bottom: 1.2rem;
            }
        }
        strong {
            font-weight: 900;
            font-size: 2.5rem;
            @media(max-width: $max-sm) {
                font-size: 1.5rem;
            }
        }
        p {
            margin-bottom: 8rem;
            @media(max-width: $max-sm) {
                margin-bottom: 4.1rem;
            }
        }
        p,
        blockquote {
            font-size: 1.8rem;
            line-height: 3rem;
            @media(max-width: $max-sm) {
                font-size: 1.5rem;
            }
        }

        blockquote {
            background-image: url('../assets/icons/mark.svg');
            background-repeat: no-repeat;
            background-size: 3.4rem;
            background-position: 0rem 0rem;
            padding-left: 6.5rem;
            @media(max-width: $max-sm) {
                padding-left: 0;
                padding-top: 4.5rem;

            }
        }
    }
    &__image {
        grid-area: image;
        position: relative;
        img {
            $heightDesktop: 64.8rem;
            position: absolute;
            right: 0;
            width: auto;
            @media(min-width: $min-md) {
                height: $heightDesktop;
                top: 50%;
                margin-top: -$heightDesktop/2;
            }
            @media(max-width: $max-sm) {
                height: 17.1rem;
                margin: 0;
                bottom: -2rem;
                right: -13rem;
            }
        }
    }
}
</style>
